import vue from "../main";

export default function() {
  return [
    { id: 1, name: vue.$t("$staticData.otherSummaryPaymentTypes.cash") },
    { id: 2, name: vue.$t("$staticData.otherSummaryPaymentTypes.ownFunds") },
    { id: 3, name: vue.$t("$staticData.otherSummaryPaymentTypes.companyCard") },
    { id: 4, name: vue.$t("$staticData.otherSummaryPaymentTypes.transfer") }
  ].sort((a, b) => (a.name > b.name ? 1 : -1));
}
